import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Typography, Box } from "@mui/material";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";

interface PayrollShuttleDetailsTableProps {
    rows: IPayrollShuttleEntry[];
}

const NOM_WIDTH = 130;
const PRENOM_WIDTH = 110;

/** Colonne figée (Nom/Prénom) dans le corps du tableau : reste visible au scroll horizontal. */
const stickyLeftSx = (left: number, width: number) => ({
    position: "sticky" as const,
    left,
    width,
    minWidth: width,
    maxWidth: width,
    zIndex: 1,
    bgcolor: "background.paper",
    boxShadow: "2px 0 4px -2px rgba(0,0,0,0.15)",
});

/** Ligne d'en-tête figée : reste visible au scroll vertical. */
const stickyTopSx = {
    position: "sticky" as const,
    top: 0,
    zIndex: 2,
    bgcolor: "background.paper",
};

/** Cellules d'en-tête Nom/Prénom : figées à la fois horizontalement et verticalement. */
const stickyTopLeftSx = (left: number, width: number) => ({
    ...stickyLeftSx(left, width),
    ...stickyTopSx,
    zIndex: 3,
});

export default function PayrollShuttleDetailsTable({ rows }: PayrollShuttleDetailsTableProps) {
    if (rows.length === 0) {
        return (
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography color="text.secondary">
                    Aucune donnée pour ce mois. Cliquez sur "Générer" pour calculer la navette de paie.
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer sx={{ maxHeight: "70vh", overflow: "auto" }}>
            <Table size="small" stickyHeader sx={{ minWidth: 1500 }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={stickyTopLeftSx(0, NOM_WIDTH)}>Nom</TableCell>
                        <TableCell sx={stickyTopLeftSx(NOM_WIDTH, PRENOM_WIDTH)}>Prénom</TableCell>
                        <TableCell sx={stickyTopSx}>Congés anticipés</TableCell>
                        <TableCell sx={stickyTopSx}>Congés payés</TableCell>
                        <TableCell sx={stickyTopSx}>Congés maternité</TableCell>
                        <TableCell sx={stickyTopSx}>Congé supp. naissance</TableCell>
                        <TableCell sx={stickyTopSx}>Maladie</TableCell>
                        <TableCell sx={stickyTopSx}>RTT</TableCell>
                        <TableCell sx={stickyTopSx}>Absence école</TableCell>
                        <TableCell sx={stickyTopSx}>Absence non rémunérée</TableCell>
                        <TableCell sx={stickyTopSx}>Jours travaillés</TableCell>
                        <TableCell sx={stickyTopSx}>Jours présence</TableCell>
                        <TableCell sx={stickyTopSx}>Jours télétravail</TableCell>
                        <TableCell sx={stickyTopSx}>Prime télétravail</TableCell>
                        <TableCell sx={stickyTopSx}>Tickets restaurant</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row._id}>
                            <TableCell sx={stickyLeftSx(0, NOM_WIDTH)}>{row.lastname}</TableCell>
                            <TableCell sx={stickyLeftSx(NOM_WIDTH, PRENOM_WIDTH)}>{row.firstname}</TableCell>
                            <TableCell>{row.leaveDays.anticipated}</TableCell>
                            <TableCell>{row.leaveDays.paidLeave}</TableCell>
                            <TableCell>{row.leaveDays.maternity}</TableCell>
                            <TableCell>{row.leaveDays.birthBonus}</TableCell>
                            <TableCell>{row.leaveDays.sickLeave}</TableCell>
                            <TableCell>{row.leaveDays.rtt}</TableCell>
                            <TableCell>{row.leaveDays.schoolAbsence}</TableCell>
                            <TableCell>{row.leaveDays.unpaidAbsence}</TableCell>
                            <TableCell>{row.workedDays}</TableCell>
                            <TableCell>{row.presentDays}</TableCell>
                            <TableCell>{row.teleworkDays}</TableCell>
                            <TableCell>{row.teleworkBonus.toFixed(2)} €</TableCell>
                            <TableCell>{row.restaurantTickets.toFixed(2)} €</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
